var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-and-darkness"},[(_vm.darkenBackground)?_c('div',{staticClass:"darkness",on:{"click":function($event){return _vm.$emit('clickAway')}}}):_vm._e(),_c('div',{staticClass:"sidebar"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }